import { render, staticRenderFns } from "./p17.vue?vue&type=template&id=f49ebfbe&scoped=true&"
import script from "./p17.vue?vue&type=script&lang=js&"
export * from "./p17.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49ebfbe",
  null
  
)

export default component.exports